<script>
   /**************************************************************/
   /* ResultsTable                                               */
   /* -------------------------                                  */
   /* shows table with SIMCA results for training and PV-sets    */
   /**************************************************************/

   // main properties of the whole app
   let { calres } = $props();
   let nrows = $derived(calres ? calres.nrows : 0);
</script>


{#if calres}
<table>
   <thead>
   <tr>
      <th></th>
      <th>Cal</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">Objects</td>
      <td>{nrows}</td>
   </tr>
   <tr>
      <td class="label">Extremes</td>
      <td>{calres.outcomes.rolsNum.extreme}</td>
   </tr>
   <tr>
      <td class="label">Outliers</td>
      <td>{calres.outcomes.rolsNum.outlier}</td>
   </tr>
   <tr>
      <td class="label">Sensitivity</td>
      <td>{calres.outcomes.stat.sensitivity.toFixed(3)}</td>
   </tr>
   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>